
export class StatisticsResult {
    constructor(
        readonly xAxis: string,
        readonly yAxis: number,
        readonly isValid: boolean,
        readonly tooltipDate: string
    ) { }
}
export class StatisticsSearch {
    constructor(
        readonly key: SearchKeyType,
        readonly numberHours: number
    ) { }
}

export enum SearchKeyType {
    GeneratedDocuments = 'generated-documents',
    GeneratedTransactions = 'generated-transactions',
    AverageWaitTime = 'average-wait-time'
}
